import React from 'react';
import { FilterBarInputContainer } from './dropdownInput.styles';
import AbstractInput from '../../abstractInput/abstractInput.jsx';

function DropdownInput(props) {
  return <AbstractInput {...props} StyledContainer={FilterBarInputContainer} />;
}

export default DropdownInput;
